import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { FCC } from '@zazume/zzm-base';

import { Box } from '../Box';

const Container = styled<any>(Box)(
  ({ theme, variant }) => css`
    gap: ${theme.spacing.md};
    max-width: ${variant === 'with-aside-content' ? undefined : '41.75rem'};
  `
);

interface PageDetailContentProps {
  variant?: 'regular' | 'with-aside-content';
}

export const PageDetailContent: FCC<PageDetailContentProps> = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};
